import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./Footer.module.css";
import dfLogo from "../assets/logo.png";
import { useInView } from "../Hooks/useInView";

const AVILA_URL = "https://www.avila-projektmanagement.de";
const AVILA_NAME = "AVILA Projektmanagement GmbH";

const Footer: React.FC = () => {
  const [ref, inView] = useInView<HTMLDivElement>(0.2);
  const year = new Date().getFullYear();

  return (
    <footer
      ref={ref}
      className={[styles.footer, inView ? styles.reveal : ""].join(" ")}
      aria-label="Seitenfuß"
    >
      <div className={styles.container}>
        <section
          className={styles.brandArea}
          aria-label="Projekte & Leistungen"
        >
          <h3 className={styles.groupTitle}>Projekte &amp; Leistungen</h3>

          <p className={styles.brandDesc}>
            <span>über unsere  Tochtergesellschaft</span>
            <strong>{AVILA_NAME}</strong>
          </p>

          <a
            href={AVILA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.brandLink}
            aria-label={`Zur Website: ${AVILA_NAME} (neuer Tab)`}
          >
            Zur Website
          </a>
        </section>

        <section className={styles.center} aria-label="Unternehmensangaben">
          <h3 className={styles.groupTitle}>Unternehmen</h3>

          <div className={styles.card}>
            <div className={styles.cardHead}>
              <img src={dfLogo} alt="" className={styles.cardLogo} />
              <div className={styles.cardName}>
                Dr. Fernando International GmbH
              </div>
            </div>

            <div className={styles.cardGrid}>
              <address className={styles.addr} aria-label="Adresse">
                <span className={styles.kicker}>Office Berlin</span>
                <div> Grunewaldstraße 24</div>
                <div> 12165 Berlin</div>
                <div>Deutschland</div>
              </address>

              <div className={styles.hours} aria-label="Öffnungszeiten">
                <span className={styles.kicker}>Öffnungszeiten</span>
                <div>
                  Mo–Fr: <time dateTime="09:00">09:00</time>–
                  <time dateTime="18:00">18:00</time>
                </div>
                <div>Sa–So: geschlossen</div>
              </div>
            </div>
          </div>
        </section>

  <nav className={styles.right} aria-label="Rechtliches">
  <h3 className={styles.groupTitle}>Navigation</h3>
  <ul className={styles.list}>
    <li>
      <NavLink to="/" className={styles.link}>
        Home
      </NavLink>
    </li>

    <li>
      <NavLink to="/projects" className={styles.link}>
        Referenzen
      </NavLink>
    </li>

    <li>
      <NavLink to="/impressum" className={styles.link}>
        Impressum
      </NavLink>
    </li>

    <li>
      <NavLink to="/datenschutz" className={styles.link}>
        Datenschutz
      </NavLink>
    </li>
  </ul>
</nav>

      </div>

      <div className={styles.bottom} role="contentinfo">
        <div className={styles.bottomInner}>
          <span>© {year} Dr. Fernando International GmbH</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
